import styled from 'styled-components';

export const StyledFormError = styled.div`
  color: red;
  font-size: 13px;
  margin: 1% 10%;
`;
